﻿import * as Model from "../../../models/models";
import * as LogService from "../../../core/services/logservice/log.service";
import {LocationIsoModalGateway} from './locationIsoModal.gateway';
import {LocationIsoModalViewModel} from './locationIsoModal.viewmodel';
import {MessageBoxService} from '../../../core/services/messageBoxService/messageBox.service';
import * as UsStates from "../../constants/stateAbbreviations/stateAbbreviations.constant";
import * as lodash from 'lodash';

export class LocationIsoModalController {

    public viewmodel: LocationIsoModalViewModel;
    public addressLookupForm: ng.IFormController;

    public static $inject = ['$uibModalInstance', 'logService', 'locationIsoModalGateway', 'ValidationService', 'messageBoxService', 'stateAbbreviations', 'data'];

    constructor(private $modalInstance: any,
        private logger: LogService.ILogService,
        private gateway: LocationIsoModalGateway,
        private validationService: any,
        private messageBoxService: MessageBoxService,
        private stateAbbreviations: UsStates.IUsStateInfo[],
        private data: any) {
        this.activate();
    }

    private activate(): void {
        // this is required in order to set up the validation service to work with the form using "controller as" syntax
        this.validationService = new this.validationService({ controllerAs: this, debounce: 600 });
        this.viewmodel = new LocationIsoModalViewModel();

        this.gateway.loadGraphModel(this.viewmodel, this.data.submission, this.data.locationAggregate)
            .then(() => {
                this.setView();
            });
    }

    public save() {

        if (this.viewmodel.showAddressForm && this.addressLookupForm.$invalid) {
            // trigger validation so that validation error messages appear on the form
            this.validationService.checkFormValidity(this);
            return;
        }

        this.viewmodel.isoProcessingStatusMessage = "Saving.";
        this.viewmodel.isAddressProcessing = true;

        const gatewaySave = (this.viewmodel.isEdit) ? 
            this.gateway.editLocation(this.viewmodel.locationCreateRequest, this.viewmodel.locationAggregate) : 
            this.gateway.addLocation(this.viewmodel.locationCreateRequest);

        gatewaySave.then((result: Model.LocationAggregate) => {
                if (result && result.address) {
                    this.close(result);
                }
                else{
                    this.setView();
                    this.viewmodel.isAddressProcessing = false;
                    this.viewmodel.isoProcessingStatusMessage = "";
                }
            })
            .catch(
            (reason: any) => {
                this.viewmodel.isAddressProcessing = false;
                this.viewmodel.isoProcessingStatusMessage = "";
                this.viewmodel.hasFailed = true;
            });
    }

    public cancel() {
        this.$modalInstance.dismiss('cancel');
    }

    private close(aggregate: Model.LocationAggregate) {
        this.$modalInstance.close(aggregate);
    }

    private setView() {
        this.viewmodel.showAddressForm = true;
        this.viewmodel.hasNoResults = false;
        this.viewmodel.hasFailed = false;

        if (this.addressLookupForm)
            this.validationService.resetForm(this.addressLookupForm);
    }
}
